import React from 'react';
import { makeStyles } from '@material-ui/core';
import { classNames } from '../../utils';
import { FemaleIcon, MenIcon } from '../Icon';
import { genderP } from '../../page/BedStatus/bsApp';

const useStyles = makeStyles((theme) => ({
  frmaleIcon: {
    color: '#ff8181',
    width: '1.063rem',
    height: '1.063rem',
    marginRight: '0.313rem',
  },
  menIcon: {
    color: '#538fff',
    width: '1.063rem',
    height: '1.063rem',
    marginRight: '0.313rem',
  },
}));
export default function GenderIcon(props) {
  const { typeName, className } = props;
  const classes = useStyles();

  const showGenderIcon = () => {
    switch (typeName) {
      case genderP.MEN:
        return <MenIcon className={classNames(classes.menIcon, className)} />;
      case genderP.FEMALE:
        return <FemaleIcon className={classNames(classes.frmaleIcon, className)} />;
      default:
        return null;
    }
  };

  return <>{showGenderIcon()}</>;
}
